import ServiceManagement from '../../common/ServiceManagement';
import RadiologyModalContainer from './RadiologyModalContainer';
import { COLUMN_RADIOLOGY } from '@/module/services/constants';
import React from 'react';

const RadiologyManagement = (props) => (
  <ServiceManagement
    {...{
      ...props,
      prefixName: 'Radiology',
      category: 'Radiologies',
      noDataHelperText: 'No radiology',
      noDataHelperSubText: 'Please create a new radiology',
      columns: COLUMN_RADIOLOGY,
      ModalContainer: RadiologyModalContainer,
      requirePlatoTestCode: true,
    }}
  />
);

export default RadiologyManagement;
